<script setup>
import { ref, inject } from 'vue';
import { dateToTimeString } from '../../../libs/dates';
import SelectorParada from './SelectorParada.vue';
import SelectorAsiento from './SelectorAsiento.vue';

const I18n = inject('I18n');

const props = defineProps({
  fechaInicio: { type: String, required: true },
  fechaFin: { type: String, required: true },
  modelValue: { type: Object, required: true },
});

const emit = defineEmits(['update:modelValue']);

const parada_id = ref(props.modelValue.parada_id);
const asiento = ref(props.modelValue.asiento);

const update = (key, value) => {
  emit('update:modelValue', { ...props.modelValue, [key]: value });
};
</script>

<template>
  <div class="row">
    <div class="col-sm-3">
      <div class="m-t-label">
        {{ modelValue.ruta.nombre }}
        {{ modelValue.nombre }}
        {{ dateToTimeString(modelValue.hora) }}
      </div>
    </div>
    <div class="form-group col-sm-3">
      <label class="control-label required">
        <abbr title="requerido">*</abbr>
        {{ I18n.t('parada') }}
      </label>
      <selector-parada
        v-model="parada_id"
        :turno-id="modelValue.id"
        @update:model-value="update('parada_id', $event)"
      />
    </div>
    <div class="form-group col-sm-6">
      <label class="control-label required">
        <abbr title="requerido">*</abbr>
        {{ I18n.t('asiento') }}
      </label>
      <selector-asiento
        v-model="asiento"
        :turno-id="modelValue.id"
        :fecha-inicio="fechaInicio"
        :fecha-fin="fechaFin"
        @update:model-value="update('asiento', $event)"
      >
      </selector-asiento>
    </div>
  </div>
</template>
